import { Invoice, updateInvoiceAsync } from '../../modules/invoices';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { Drawer } from 'antd';
import { useEffect, useState } from 'react';
import { getInvoiceCommon } from '../../api/constlink';
import InvoiceCreateUpdateComponent from '../../components/invoices/InvoiceCreateUpdateComponent';
import {
  getInvoiceFileAPIPath,
  initializeUploadProps2,
} from '../../util/utils';
import Title from 'antd/lib/typography/Title';

interface InvoiceEditDrawerProps {
  config: any;
  invoice: Invoice;
  visible: boolean;
  onClose: () => void;
}

function InvoiceEditDrawer({
  config,
  invoice,
  visible,
  onClose,
}: InvoiceEditDrawerProps) {
  const [invoiceCommon, setInvoiceCommon] = useState<any>();
  const [uploadProps, setUploadProps] = useState<any>();
  const dispatch = useDispatch();
  useEffect(() => {
    if (config === null) return;
    if (!visible) return;
    (async () => {
      setUploadProps(
        await initializeUploadProps2(
          getInvoiceFileAPIPath(config.enterpriseId, config.projectId),
        ),
      );
      const invoiceCommon = await getInvoiceCommon(config.enterpriseId);
      setInvoiceCommon({ ...invoiceCommon });
    })();
  }, [config, visible]);

  useEffect(() => {
    (async () => {
      const invoiceCommon = await getInvoiceCommon(config.enterpriseId);
      setInvoiceCommon({
        ...invoiceCommon,
      });
    })();
  }, [config]);

  const onUpdate = async (data: any) => {
    const invoiceObj = {
      ...data,
      billingDate: moment(data.billingDate).format('YYYY-MM-DD'),
      vendorId: data.vendor.id,
    };
    if (invoiceObj.file) {
      for (const _file of invoiceObj.file) {
        if ('response' in _file) {
          _file.path = _file.response.path;
          _file.mimeType = _file.response.mimeType;
        }
      }
    }

    /**
     * 프로젝트 레벨 청구서 수정 시
     *  - ('projectId' in config)
     * 회사 레벨 청구서 수정 시
     *  - (data.project && data.project.id !== '')
     */
    if ('projectId' in config) {
      invoiceObj.projectId = +config.projectId;
    } else {
      if (data.project && data.project.id !== '')
        invoiceObj.projectId = data.project.id;
    }

    if (data.gongjong === undefined) invoiceObj.gongjong = null;

    dispatch(updateInvoiceAsync.request({ ...config, invoice: invoiceObj }));
    onClose();
  };

  return (
    <>
      {invoice && invoiceCommon && (
        <Drawer
          width={800}
          placement="right"
          closable={true}
          onClose={onClose}
          open={visible}
          maskClosable={false}
          title={<Title level={3}>청구서 수정</Title>}
        >
          {visible && (
            <InvoiceCreateUpdateComponent
              invoice={invoice}
              invoiceCommon={invoiceCommon}
              uploadProps={uploadProps}
              isProjectLevel={!!config.projectId}
              onCreate={onUpdate}
              onCancel={onClose}
            />
          )}
        </Drawer>
      )}
    </>
  );
}

export default InvoiceEditDrawer;
